module.exports = __webpack_public_path__ + "images/marketing_site/CRM_HighestUserAdoption_Enterprise_Adoption.svg";